module.exports = __webpack_public_path__ + "img/1440.730141f3.jpg";